import { FaUsers, FaFileContract, FaHandHoldingUsd, FaSignOutAlt, FaUserFriends, FaCog, FaBalanceScale, FaUserShield } from "react-icons/fa";
import { LuReceipt } from "react-icons/lu";
import { useNavigate } from "react-router-dom";
import logo from "../gsult.png";
import "../Dashboard.css";
import { rolesMapping } from "../utils/RolesUtils";
import { getUserLogged, hasAnyRole } from "../utils/TokenUtils";

const Dashboard = ({ handleLogout }) => {
    const navigate = useNavigate();
    const userName = getUserLogged();

    const options = [
        { icon: <FaUsers />, text: "Clientes", path: "/clientes", group: "Gestão", rolesMapping: [...rolesMapping.clientes, ...rolesMapping.admin] },
        { icon: <FaFileContract />, text: "Contratos", path: "/contratos", group: "Gestão", rolesMapping: [...rolesMapping.contratos, ...rolesMapping.admin] },
        { icon: <FaUserFriends />, text: "Equipe", path: "/colaboradores", group: "Gestão", rolesMapping: [...rolesMapping.colaboradores, ...rolesMapping.admin] },

        { icon: <FaUserShield />, text: "Usuários", path: "/admin/usuarios", group: "Gestão", rolesMapping: [...rolesMapping.admin] },
        
        { icon: <FaHandHoldingUsd />, text: "Comissões", path: "/comissao", group: "Financeiro", rolesMapping: [...rolesMapping.comissao, ...rolesMapping.admin] },
        { icon: <LuReceipt />, text: "Despesas", path: "/despesas", group: "Financeiro", rolesMapping: [...rolesMapping.despesas, ...rolesMapping.admin] },
        { icon: <FaBalanceScale />, text: "Balanço", path: "/balancofinanceiro", group: "Financeiro", rolesMapping: [...rolesMapping.balancofinanceiro, ...rolesMapping.admin] },
        { icon: <FaCog />, text: "Config. despesas", path: "/configdespesas", group: "Configuração", rolesMapping: [...rolesMapping.configdespesas, ...rolesMapping.admin] },
    ];

    const visibleOptions = options.filter((option) => hasAnyRole(option.rolesMapping));

    return (
        <main className="dashboard-container">
            <header className="dashboard-topbar">
                <div className="dashboard-logo-frame">
                    <img src={logo} alt="Gsult Consultoria" className="dashboard-logo" />
                </div>
                <div className="dashboard-user">
                    <span>{userName}</span>
                    <button type="button" className="logout-button" onClick={handleLogout}>
                        <FaSignOutAlt aria-hidden="true" /> Sair
                    </button>
                </div>
            </header>

            <section className="dashboard-welcome" aria-labelledby="dashboard-title">
                {/* <p className="dashboard-eyebrow">Painel administrativo</p> */}
                <h1 id="dashboard-title">Olá, {userName} <span aria-hidden="true">👋</span></h1>
                <p>Bem-vindo ao painel da Gsult Consultoria.</p>
            </section>

            {["Gestão", "Financeiro", "Configuração"].map((group) => {
                const groupOptions = visibleOptions.filter((option) => option.group === group);
                if (!groupOptions.length) return null;

                return (
                    <section className="dashboard-section" key={group} aria-labelledby={`section-${group}`}>
                        <h2 id={`section-${group}`}>{group === "Gestão" ? "Gestão" : group}</h2>
                        <div className="dashboard-grid">
                            {groupOptions.map((option) => (
                                <button key={option.path} type="button" className="dashboard-item" onClick={() => navigate(option.path)}>
                                    <span className="icon" aria-hidden="true">{option.icon}</span>
                                    <span>{option.text}</span>
                                </button>
                            ))}
                        </div>
                    </section>
                );
            })}
        </main>
    );
};

export default Dashboard;
